"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _defineProperty = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$BUILTIN_CONT;

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", " !important;\n  margin-right: ", " !important;\n  opacity: 0.75;\n  color: white;\n  &:not(.nothing) {\n    ", "\n    ", "\n    margin-left: ", " !important;\n    margin-right: ", " !important;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  cursor: ", ";\n  opacity: 0.8;\n  transition: opacity 0.1s linear;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerFooter = exports.PlayerFooterCompactMode = exports.BUILTIN_CONTROLS = exports.FooterControl = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../../icons");

var LoadingIndicator_1 = require("../ant/LoadingIndicator");

var common_1 = require("../common");

var ClickableContainer_1 = require("../dom/ClickableContainer");

var styled_1 = require("../styled");

var theme_1 = require("../theme");

var typography_1 = require("../typography");

var MediaPlaybackContext_1 = require("./MediaPlaybackContext");

var PlayerFooterContainer_1 = require("./PlayerFooterContainer");

var Track_1 = require("./Track");

var Fullscreen_1 = require("./controls/Fullscreen");

var PlaybackSpeed_1 = require("./controls/PlaybackSpeed");

var Skip_1 = require("./controls/Skip");

var Volume_1 = require("./controls/Volume");

var FooterControl;

(function (FooterControl) {
  FooterControl["SkipBackward"] = "skip-backward";
  FooterControl["SkipForward"] = "skip-forward";
  FooterControl["Fullscreen"] = "fullscreen";
  FooterControl["PlaybackSpeed"] = "playback-speed";
  FooterControl["Volume"] = "volume";
})(FooterControl = exports.FooterControl || (exports.FooterControl = {}));

exports.BUILTIN_CONTROLS = (_exports$BUILTIN_CONT = {}, _defineProperty(_exports$BUILTIN_CONT, FooterControl.SkipBackward, Skip_1.SkipBackward), _defineProperty(_exports$BUILTIN_CONT, FooterControl.SkipForward, Skip_1.SkipForward), _defineProperty(_exports$BUILTIN_CONT, FooterControl.Fullscreen, Fullscreen_1.Fullscreen), _defineProperty(_exports$BUILTIN_CONT, FooterControl.PlaybackSpeed, PlaybackSpeed_1.PlaybackSpeed), _defineProperty(_exports$BUILTIN_CONT, FooterControl.Volume, Volume_1.Volume), _exports$BUILTIN_CONT);
var PlayerFooterCompactMode;

(function (PlayerFooterCompactMode) {
  PlayerFooterCompactMode[PlayerFooterCompactMode["Compact"] = 0] = "Compact";
  PlayerFooterCompactMode[PlayerFooterCompactMode["UltraCompact"] = 1] = "UltraCompact";
})(PlayerFooterCompactMode = exports.PlayerFooterCompactMode || (exports.PlayerFooterCompactMode = {}));

function PlayerFooter(_ref) {
  var beforeFooter = _ref.beforeFooter,
      decorators = _ref.decorators,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? [FooterControl.SkipBackward, FooterControl.SkipForward, FooterControl.PlaybackSpeed, FooterControl.Volume, FooterControl.Fullscreen] : _ref$controls,
      compact = _ref.compact,
      hideFullscreen = _ref.hideFullscreen,
      visible = _ref.visible;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      isPlaying = _ref2.isPlaying,
      onSetPlaying = _ref2.onSetPlaying,
      isBuffering = _ref2.isBuffering,
      duration = _ref2.duration,
      playedSeconds = _ref2.playedSeconds;

  var theme = (0, theme_1.useTheme)();
  var PlayStatusIcon;

  if (isPlaying && !isBuffering) {
    PlayStatusIcon = icons_1.PauseOutline;
  } else if (isBuffering || !duration) {
    PlayStatusIcon = LoadingIndicator_1.LoadingIndicator;
  } else {
    PlayStatusIcon = icons_1.PlayOutline;
  }

  return react_1.default.createElement(react_1.default.Fragment, null, beforeFooter, react_1.default.createElement(PlayerFooterContainer_1.PlayerFooterContainer, {
    compact: compact !== undefined,
    visible: visible
  }, react_1.default.createElement(PlayStatusContainer, {
    compact: compact,
    onClick: function onClick() {
      if (!isBuffering) {
        onSetPlaying(function (p) {
          return !p;
        });
      }
    },
    isBuffering: isBuffering
  }, react_1.default.createElement(PlayStatusIcon, {
    width: (0, theme_1.getSize)(theme, compact !== undefined ? '@size-m' : '@size-l'),
    height: (0, theme_1.getSize)(theme, compact !== undefined ? '@size-m' : '@size-l'),
    size: compact !== undefined ? '@size-s' : '@size-m',
    color: 'white'
  })), compact === PlayerFooterCompactMode.Compact ? null : react_1.default.createElement(Track_1.Track, null, decorators), duration && compact !== PlayerFooterCompactMode.UltraCompact ? react_1.default.createElement(TextContainer, {
    compact: compact !== undefined,
    lineHeight: common_1.isNative ? 1.4 : 1
  }, "".concat((0, common_1.formatTime)(playedSeconds.toString()), " / ").concat((0, common_1.formatTime)(duration.toString()))) : null, compact !== PlayerFooterCompactMode.UltraCompact ? controls.filter(function (control) {
    if (react_1.default.isValidElement(control) || !hideFullscreen) return true;
    return control !== FooterControl.Fullscreen;
  }).filter(function (control) {
    if (react_1.default.isValidElement(control)) return true;
    return compact === undefined || control !== FooterControl.SkipBackward && control !== FooterControl.SkipForward && control !== FooterControl.PlaybackSpeed;
  }).map(function (control, index) {
    if (react_1.default.isValidElement(control)) {
      return react_1.default.cloneElement(control, {
        key: index,
        isCompact: compact !== undefined
      });
    } else {
      var Control = exports.BUILTIN_CONTROLS[control];
      return react_1.default.createElement(Control, {
        key: control,
        compact: compact
      });
    }
  }) : null));
}

exports.PlayerFooter = PlayerFooter;
var PlayStatusContainer = (0, styled_1.styled)(ClickableContainer_1.ClickableContainer)(_templateObject(), function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact ? '@size-m' : '@size-l');
}, function (props) {
  return props.isBuffering ? undefined : 'pointer';
}, function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact ? '@size-m' : '@size-l');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact ? '@size-m' : '@size-l');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact === PlayerFooterCompactMode.Compact ? '@size-xxs' : props.compact === PlayerFooterCompactMode.UltraCompact ? '@size-s' : '@size-m');
}, function (props) {
  return common_1.isNative ? '' : "\n    &:hover {\n      opacity: ".concat(props.isBuffering ? 0.8 : 1, ";\n    }\n  ");
});
var TextContainer = (0, styled_1.styled)(typography_1.BodySmall)(_templateObject2(), function (props) {
  return props.compact ? 'auto' : (0, theme_1.getSize)(props.theme, '@size-s');
}, function (props) {
  return props.compact ? 'auto' : 0;
}, function (props) {
  return common_1.isNative ? '' : "font-family: ".concat(props.theme['@font-family'], " !important;");
}, function (props) {
  return common_1.isNative ? '' : "font-size: ".concat(props.theme['@font-size-sm'], " !important;");
}, function (props) {
  return props.compact ? 'auto' : (0, theme_1.getSize)(props.theme, '@size-s');
}, function (props) {
  return props.compact ? 'auto' : 0;
});